var _defs, _rect, _g, _g2, _g3, _path, _path2, _path3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevopsIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770 445",
    width: 770,
    height: 445,
    role: "img",
    "aria-label": "DevOps infinity loop with CI/CD pipeline stages",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loop",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a2dec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c2ede"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 770,
    height: 445,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9cbf3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 70,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 390,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 390,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95 130 a26 26 0 0 1 8 -51 a34 34 0 0 1 66 -6 a24 24 0 0 1 4 47 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 118 v-30 m0 0 l-12 12 m12 -12 l12 12",
    stroke: "#9c2ede",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 66,
    width: 110,
    height: 96,
    rx: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 78,
    width: 86,
    height: 20,
    rx: 5,
    fill: "#ece3fb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 104,
    width: 86,
    height: 20,
    rx: 5,
    fill: "#ece3fb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 130,
    width: 86,
    height: 20,
    rx: 5,
    fill: "#ece3fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 88,
    r: 4,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 114,
    r: 4,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 140,
    r: 4,
    fill: "#ffd166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 88 h50 M648 114 h50 M648 140 h50",
    stroke: "#c6aef0",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385 185 C330 110 205 110 205 185 C205 260 330 260 385 185 C440 110 565 110 565 185 C565 260 440 260 385 185",
    fill: "none",
    stroke: "url(#loop)",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279 122 l18 -6 l-4 18 z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491 248 l-18 6 l4 -18 z",
    fill: "#ffffff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6a2dec",
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 165 l-20 20 l20 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 165 l20 20 l-20 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 158 l-14 56"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(478,185)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9c2ede"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -42,
    width: 14,
    height: 84,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -42,
    width: 14,
    height: 84,
    rx: 6,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -42,
    width: 14,
    height: 84,
    rx: 6,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -42,
    width: 14,
    height: 84,
    rx: 6,
    transform: "rotate(135)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "#9c2ede"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#f3edfc"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120 372 h530",
    stroke: "#c6aef0",
    strokeWidth: 4,
    strokeDasharray: "2 10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 342,
    width: 120,
    height: 60,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 366,
    r: 7,
    fill: "none",
    stroke: "#6a2dec",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 373 v14 m0 -28 v-4",
    stroke: "#6a2dec",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 378,
    fontFamily: "Arial, sans-serif",
    fontSize: 17,
    fontWeight: "bold",
    fill: "#4a3f66"
  }, "Commit")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 342,
    width: 110,
    height: 60,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 360 l12 -7 l12 7 v14 l-12 7 l-12 -7 z M272 360 l12 7 l12 -7 M284 367 v14",
    fill: "none",
    stroke: "#6a2dec",
    strokeWidth: 4.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 378,
    fontFamily: "Arial, sans-serif",
    fontSize: 17,
    fontWeight: "bold",
    fill: "#4a3f66"
  }, "Build")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 342,
    width: 105,
    height: 60,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 372,
    r: 14,
    fill: "none",
    stroke: "#4caf7d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 372 l5 5 l9 -10",
    stroke: "#4caf7d",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 447,
    y: 378,
    fontFamily: "Arial, sans-serif",
    fontSize: 17,
    fontWeight: "bold",
    fill: "#4a3f66"
  }, "Test")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 342,
    width: 130,
    height: 60,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 384 c-2 -12 2 -26 12 -34 c10 8 14 22 12 34 l-6 -6 h-12 z",
    fill: "#9c2ede"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 362,
    r: 4,
    fill: "#f3edfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574 386 q6 8 12 0",
    stroke: "#ffd166",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 378,
    fontFamily: "Arial, sans-serif",
    fontSize: 17,
    fontWeight: "bold",
    fill: "#4a3f66"
  }, "Deploy")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevopsIllustration);
export default __webpack_public_path__ + "static/media/devops-illustration.11df16266f0665e44c0cac677b9c078c.svg";
export { ForwardRef as ReactComponent };